import { useState, useEffect } from "react";
import chemPro from "../../assets/images/chem-pro.jpg";
import { config } from "../config";
import { Link } from "react-router-dom";
import { useInView } from 'react-intersection-observer';
import axios from "axios";

const FeaturedSection = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios
            // .get("http://localhost/elementeers_crm/api/product_category")
            .get("https://admin.elementeers.com/api/product_category")
            .then((response) => {
                setData(response.data.product_category);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <div className="features-area pt-80 pb-50 bg-f7fafd">
                <div className="container">
                    <div className="section-title">
                        <h2>Featured Categories</h2>
                        {/* <div className="bar"></div> */}
                    </div>
                    <div className="row">
                        {data.map((item) => (
                            <div
                                className="col-lg-3 col-md-6"
                            >
                                <div className="single-features">
                                    <Link
                                        to={`${config.appUrl}${item.slug}`}
                                        className=""
                                    >
                                        <img  src={`${config.imageUrl}/product/categories/${item.image}`} width={316} />
                                        <h3>
                                            <span className="feature-id">
                                               {item.name}
                                            </span>
                                        </h3>
                                    </Link>
                                </div>
                            </div>
                         ))}
                    </div>
                    {/* <div className="text-center">
                        <button className="category-product">View All <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="black" stroke-width="2">
                            <polyline points="6 4 12 10 6 16" stroke-linecap="round" stroke-linejoin="round" />
                            <polyline points="12 4 18 10 12 16" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default FeaturedSection;
